"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ADD_PREFIX: () => ADD_PREFIX,
  ADD_TEXT: () => ADD_TEXT,
  DESELECT_OBJECTS: () => DESELECT_OBJECTS,
  MAIN_SELECT: () => MAIN_SELECT,
  default: () => src_default,
  params: () => params
});
module.exports = __toCommonJS(src_exports);
var import_google_tag_manager = __toESM(require("@analytics/google-tag-manager"));
var import_mixpanel = __toESM(require("@analytics/mixpanel"));
var import_env3 = __toESM(require("@repo/env"));
var import_analytics = __toESM(require("analytics"));

// src/apiEventStreamingPlugin.ts
var import_env = __toESM(require("@repo/env"));
var import_fetchRetry = require("@repo/transport/fetchRetry");
var import_token = require("@repo/transport/token");
var import_noop = __toESM(require("lodash/noop"));
var USER_API_URL = import_env.default.apiUrl;
var createUserEvent = async (event, content) => {
  const headers = {
    "Content-Type": "application/json"
  };
  const token = (0, import_token.getProfileToken)();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  await (0, import_fetchRetry.fetchRetry)(`${USER_API_URL}/events`, {
    method: "POST",
    headers,
    body: JSON.stringify({ type: event, data: content })
  });
  return;
};
function apiEventStreamingPlugin() {
  return {
    name: "apiEventStreaming",
    initialize: import_noop.default,
    page: import_noop.default,
    track: async ({ payload }) => {
      try {
        const { event, properties } = payload;
        await createUserEvent(event, properties);
      } catch (_error) {
      }
    },
    identify: import_noop.default,
    reset: import_noop.default
  };
}

// src/apiPlugin.ts
var import_env2 = __toESM(require("@repo/env"));
var import_fetchRetry2 = require("@repo/transport/fetchRetry");
var import_token2 = require("@repo/transport/token");
var import_noop2 = __toESM(require("lodash/noop"));
var USER_API_URL2 = import_env2.default.apiUrl;
var createUserEvent2 = async (event, content) => {
  if (!(0, import_token2.getProfileToken)()) {
    return;
  }
  await (0, import_fetchRetry2.fetchRetry)(`${USER_API_URL2}/events/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${(0, import_token2.getProfileToken)()}`
    },
    body: JSON.stringify({ type: event, data: JSON.stringify(content) })
  });
  return;
};
function apiPlugin() {
  return {
    name: "api",
    initialize: import_noop2.default,
    page: import_noop2.default,
    track: async ({ payload }) => {
      try {
        const { event, properties } = payload;
        await createUserEvent2(event, properties);
      } catch (_error) {
      }
    },
    identify: import_noop2.default,
    reset: import_noop2.default
  };
}

// src/customerIoPlugin.ts
function customerIoPlugin(pluginConfig = {}) {
  let initialPageViewFired = false;
  let trackedEvents = [];
  return {
    name: "customerio",
    config: pluginConfig,
    initialize: ({ config }) => {
      if (typeof window === "undefined") {
        return;
      }
      const { siteId } = config;
      if (!siteId || window._cio) {
        return;
      }
      if (!window._cio) {
        (function() {
          let c;
          window._cio = [];
          const a = function(f) {
            return function(...args) {
              window._cio.push([f, ...args]);
            };
          };
          const b = ["load", "identify", "sidentify", "track", "page"];
          for (c = 0; c < b.length; c++) {
            window._cio[b[c]] = a(b[c]);
          }
          const t = document.createElement("script");
          const s = document.getElementsByTagName("script")[0];
          t.async = true;
          t.id = "cio-tracker";
          t.setAttribute("data-site-id", siteId);
          t.setAttribute("data-use-in-app", "true");
          t.src = "https://assets.customer.io/assets/track-eu.js";
          s?.parentNode?.insertBefore(t, s);
        })();
      }
    },
    page: ({ payload }) => {
      if (!payload.userId) {
        return;
      }
      if (typeof window === "undefined") {
        return;
      }
      if (typeof window?._cio === "undefined") {
        return;
      }
      if (!initialPageViewFired) {
        initialPageViewFired = true;
        return;
      }
      window._cio.page(document.location.href, payload.properties);
    },
    reset: ({ instance }) => {
      const { storage } = instance;
      const opts = { storage: "cookie" };
      storage.removeItem("_cio", opts);
      storage.removeItem("_cioid", opts);
      trackedEvents = [];
    },
    track: ({ payload }) => {
      const { userId, event, properties } = payload;
      if (!userId) {
        return;
      }
      if (typeof window === "undefined") {
        return;
      }
      if (typeof window._cio === "undefined") {
        return;
      }
      trackedEvents.push(event);
      window._cio.track(event, properties);
    },
    identify: ({ payload }) => {
      const { userId, traits } = payload;
      if (typeof window === "undefined") {
        return;
      }
      if (typeof window?._cio === "undefined") {
        return;
      }
      if (!userId) {
        return;
      }
      window._cio.identify({
        id: userId,
        ...traits
      });
    },
    loaded: () => {
      if (typeof window === "undefined") {
        return false;
      }
      if (typeof window._cio === "undefined") {
        return false;
      }
      return !!window._cio;
    }
  };
}
var customerIoPlugin_default = customerIoPlugin;

// src/debugPlugin.ts
function debugPlugin() {
  return {
    name: "debug",
    initialize: ({ payload }) => {
      if (typeof window !== "undefined") {
        console.log("[analytics] initialize", payload);
      }
    },
    page: ({ payload }) => {
      console.log("[analytics] page", { ...payload });
    },
    track: ({ payload }) => {
      console.log("[analytics] track", { ...payload });
    },
    identify: ({ payload }) => {
      console.log("[analytics] identify", { ...payload });
    },
    reset: () => {
      console.log("[analytics] reset");
    }
  };
}

// src/utils.ts
var urlParams = new URLSearchParams(
  typeof window === "undefined" ? void 0 : window?.location?.search
);
var DEBUG_ANALYTICS_QUERY_PARAM = "__debug_analytics";
var debugAnalytics = Boolean(urlParams.get(DEBUG_ANALYTICS_QUERY_PARAM));
var params = {
  debugAnalytics
};

// src/events.ts
var ADD_PREFIX = "add";
var ADD_TEXT = `${ADD_PREFIX}:text`;
var MAIN_PREFIX = "main";
var MAIN_SELECT = `${MAIN_PREFIX}:select`;
var MISC_PREFIX = "misc";
var DESELECT_OBJECTS = `${MISC_PREFIX}:deselectObjects`;

// src/index.ts
var plugins = [];
if (import_env3.default.mixpanelToken && import_env3.default.nodeEnv !== "test") {
  plugins.push(
    (0, import_mixpanel.default)({
      token: import_env3.default.mixpanelToken,
      pageEvent: "pageView",
      options: {
        ignore_dnt: true,
        record_sessions_percent: 1,
        // 1% of sessions to be capturing thanks to replays - https://docs.mixpanel.com/docs/session-replay
        record_canvas: false
        // Disabled to prevent performance impact from recording canvas at 15 FPS
      }
    })
  );
}
if (import_env3.default.gtmId && import_env3.default.nodeEnv === "production") {
  plugins.push(
    (0, import_google_tag_manager.default)({
      containerId: import_env3.default.gtmId,
      debug: params.debugAnalytics
    })
  );
}
if (import_env3.default.customerIoSiteId && import_env3.default.nodeEnv === "production") {
  plugins.push(
    customerIoPlugin_default({
      siteId: import_env3.default.customerIoSiteId
    })
  );
}
plugins.push(apiPlugin());
plugins.push(apiEventStreamingPlugin());
if (params.debugAnalytics) {
  plugins.push(debugPlugin());
}
var analytics = (0, import_analytics.default)({
  app: "kittl",
  debug: params.debugAnalytics,
  plugins: [...plugins]
});
analytics.on("identifyStart", ({ payload }) => {
  payload.options.plugins = {
    ...payload.options.plugins,
    debug: params.debugAnalytics
  };
});
analytics.on("pageStart", ({ payload }) => {
  payload.options = {
    ...payload.options,
    plugins: {
      // these plugins are only enabled for specific conditions
      api: false,
      apiEventStreaming: false,
      customerio: false,
      // page events are tracked in mixpanel and gtm always (if they are loaded/enabled)
      mixpanel: true,
      "google-tag-manager": true,
      debug: params.debugAnalytics,
      // allow options passed via .page call to override defaults
      ...payload.options.plugins
    }
  };
});
analytics.on("trackStart", ({ payload }) => {
  payload.options = {
    ...payload.options,
    plugins: {
      // these plugins are only enabled for specific conditions
      api: false,
      customerio: false,
      apiEventStreaming: false,
      // mixpanel events are tracked only for logged in users or specific events (configured in userStore)
      mixpanel: false,
      // track these events in mixpanel always (if they are loaded/enabled)
      "google-tag-manager": true,
      debug: params.debugAnalytics,
      // allow options passed via .track call to override defaults
      ...payload.options.plugins
    }
  };
});
var src_default = analytics;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ADD_PREFIX,
  ADD_TEXT,
  DESELECT_OBJECTS,
  MAIN_SELECT,
  params
});
